import { Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig } from '../../../config/hotel-tours-list-page.config';

@Component({
  selector: 'app-hotel-wishlist-popup',
  templateUrl: './hotel-wishlist-popup.component.mobile.html',
  styleUrls: ['./hotel-wishlist-popup.component.mobile.scss'],
  imports: [CommonModule],
  standalone: true,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('400ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('400ms ease-in', style({ opacity: 0, transform: 'translateY(20px)' }))
      ])
    ])
  ]
})
export class HotelWishlistPopupComponent implements OnInit {
  @Input() isAdded = true;
  messages: any = {};

  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) private appConfig: HotelToursPageConfig) {
    this.messages = this.appConfig.translates.wishlist.wishlistHotelPopup;
  }

  ngOnInit() {}

  get linkToWishlist() {
    return '/tour-hunter';
  }
}
